export default __webpack_public_path__ + "static/Course-Management-a538787c5f7e4a5bf4de40a71ff24f3b.webp";